import { useEffect, useState } from 'react';

export default function QRApplyPage() {
  const [qrUrl, setQrUrl] = useState('');
  const targetUrl = 'https://www.rulerlogistics.com/#apply';

  useEffect(() => {
    // Prevent search engines from indexing this utility page
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => { meta.remove(); };
  }, []);

  useEffect(() => {
    const encoded = encodeURIComponent(targetUrl);
    setQrUrl(
      `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encoded}&bgcolor=1a1a2e&color=D4A017&margin=20`
    );
  }, []);

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] flex flex-col items-center justify-center p-8 font-sans">

      {/* Print button */}
      <div className="print:hidden mb-8 text-center">
        <p className="text-gray-400 text-sm mb-4">Print or screenshot and place on trucks, parking lots, bulletin boards!</p>
        <button
          onClick={handlePrint}
          className="bg-[#D4A017] text-[#1a1a2e] px-8 py-3 rounded-full font-bold text-sm hover:bg-[#b8880f] transition-colors cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
        >
          <i className="ri-printer-line"></i>
          Print QR Code
        </button>
      </div>

      {/* Printable card */}
      <div className="bg-[#1a1a2e] border-2 border-[#D4A017] rounded-3xl p-10 max-w-sm w-full text-center print:shadow-none print:rounded-none print:border-4">

        {/* Top badge */}
        <div className="inline-flex items-center gap-2 bg-[#D4A017]/10 border border-[#D4A017]/40 rounded-full px-4 py-1 mb-6">
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-truck-line text-[#D4A017] text-sm"></i>
          </div>
          <span className="text-[#D4A017] text-xs font-bold tracking-widest uppercase">Driver Recruiting</span>
        </div>

        {/* Logo */}
        <img
          src="https://public.readdy.ai/ai/img_res/7ccc49fe-77a5-4275-9666-278e2d510b1b.png"
          alt="Ruler Logistics LLC"
          className="h-20 w-auto object-contain mx-auto mb-5"
        />

        {/* Headline */}
        <h1 className="text-white font-extrabold text-2xl mb-1 leading-tight">
          Looking for a Driving Job?
        </h1>
        <p className="text-[#D4A017] font-semibold text-base mb-2">Join the Ruler Logistics Team!</p>
        <p className="text-gray-400 text-xs mb-6 leading-relaxed">
          Competitive Pay · Benefits · Paid Vacation Time
        </p>

        {/* QR Code */}
        <div className="flex items-center justify-center mb-5">
          <div className="p-3 bg-white rounded-2xl">
            {qrUrl ? (
              <img
                src={qrUrl}
                alt="QR kod - Drive With Us aplikacija"
                className="w-52 h-52 rounded-lg"
              />
            ) : (
              <div className="w-52 h-52 bg-gray-100 rounded-lg flex items-center justify-center">
                <span className="text-gray-400 text-sm">Učitavanje...</span>
              </div>
            )}
          </div>
        </div>

        {/* Scan instruction */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-qr-scan-2-line text-[#D4A017] text-lg"></i>
          </div>
          <span className="text-gray-300 text-sm font-medium">Scan with your phone camera to apply!</span>
        </div>

        {/* Steps */}
        <div className="flex justify-center gap-6 mb-7">
          {[
          { icon: 'ri-qr-scan-line', label: 'Scan' },
            { icon: 'ri-file-text-line', label: 'Fill Out' },
            { icon: 'ri-check-double-line', label: 'Done!' },
          ].map((step, i) => (
            <div key={i} className="flex flex-col items-center gap-1">
              <div className="w-9 h-9 flex items-center justify-center bg-[#D4A017]/10 border border-[#D4A017]/30 rounded-full">
                <i className={`${step.icon} text-[#D4A017] text-base`}></i>
              </div>
              <span className="text-gray-400 text-[10px] font-medium">{step.label}</span>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-white/10 pt-5">
          <p className="text-white font-bold text-sm">Ruler Logistics LLC</p>
          <p className="text-gray-500 text-xs mt-1">Chicago, Illinois, USA</p>
          <div className="flex items-center justify-center gap-4 mt-2">
            <span className="text-[#D4A017] text-xs font-semibold">+1 (630) 202-4180</span>
            <span className="text-gray-600 text-xs">|</span>
            <span className="text-[#D4A017] text-xs font-semibold">rulerlogistics@gmail.com</span>
          </div>
        </div>

        {/* URL */}
        <p className="text-gray-700 text-[10px] mt-4 break-all">{targetUrl}</p>
      </div>

    </div>
  );
}
